// Port of api/fuel/app/classes/insights/player/init.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Config from 'offline/model/config'
import Util from 'offline/util'

function monthIndex(ts) {
	var y = parseInt(Util.date('Y', ts), 10)
	var m = parseInt(Util.date('c', ts), 10)
	return ((y - 1970) * 12) + (m - 1)
}

function weekIndex(ts) {
	return Math.floor(dayIndex(ts) / 7)
}

function dayIndex(ts) {
	return Math.floor(ts / Constants.TIME_DAY)
}

function hIndex(plays) {
	if (!plays.length) return 0
	var counts = {}
	for (var i = 0; i < plays.length; i++) {
		var gameId = parseInt(plays[i], 10)
		if (!counts[gameId]) counts[gameId] = 0
		counts[gameId]++
	}
	var values = Object.keys(counts).map(function(key) { return counts[key] }).sort(function(a, b) { return b - a })
	var h = 0
	for (var j = 0; j < values.length; j++) {
		var rank = j + 1
		if (values[j] >= rank) h = rank
		else break
	}
	return h
}

export default Segment.extend({
	name: 'init',
	priority: 10,
	types: [Constants.TYPE_USER],
	run: function(type, owner, userIndex, detail, filter, vars) {
		var userId = owner.get_id()
		var config = Config.user(userId)
		var usernames = ((config.plays || {}).usernames || []).slice()
		var playersFilter = (filter && filter.players) ? parseInt(filter.players, 10) : 0
		var range = this.get_period_date_range(type, owner, filter || {})
		var validPlaysIndex = []
		this._data.games = []

		// Raw query rather than Play.collection() / Game.where() / Player.filter()
		// to avoid instantiating thousands of Model objects. Same fix as
		// players/init.js, records/init.js, etc.
		var playWhereSql = 'user_id = ' + userId +
			' AND play_date >= ' + range.start +
			' AND play_date < ' + range.end
		if (playersFilter) playWhereSql += ' AND play_players = ' + playersFilter

		var playRows = Util.queryFast(
			'SELECT play_id, game_id, play_date, play_length, play_count, play_players' +
			' FROM play WHERE ' + playWhereSql + ' ORDER BY play_date ASC'
		)
		var playIds = []
		var playsRaw = {}
		var gameIdSet = {}
		for (var pi = 0; pi < playRows.length; pi++) {
			var row = playRows[pi]
			var pid = row.play_id | 0
			var gid = row.game_id | 0
			playIds.push(pid)
			playsRaw[pid] = {
				id: pid,
				g: gid,
				d: row.play_date | 0,
				l: row.play_length | 0,
				c: row.play_count | 0,
				pl: row.play_players | 0,
				w: 0,
				playersIndex: [],
				playersKey: ''
			}
			if (gid) gameIdSet[gid] = true
		}

		if (playIds.length) {
			var gameIdList = Object.keys(gameIdSet).map(function(s) { return parseInt(s, 10) })
			if (gameIdList.length) {
				var weightRows = Util.queryFast(
					'SELECT game_id, game_weight_avg FROM game WHERE game_id IN(' + Util.in(gameIdList) + ')'
				)
				var gameWeightById = {}
				for (var gw = 0; gw < weightRows.length; gw++) {
					gameWeightById[weightRows[gw].game_id | 0] = parseFloat(weightRows[gw].game_weight_avg) || 0
				}
				for (var pw = 0; pw < playIds.length; pw++) {
					var playId = playIds[pw]
					playsRaw[playId].w = gameWeightById[playsRaw[playId].g] || 0
				}
			}
		}

		var playersRaw = playIds.length ? Util.queryFast(
			'SELECT player_id AS pid, user_id AS u, player_name AS n, play_id AS p, player_win AS w' +
			' FROM player WHERE play_id IN(' + Util.in(playIds) + ')'
		) : []

		var players = []
		var playersByID = {}
		var playersByName = {}

		for (var i = 0; i < playersRaw.length; i++) {
			var player = playersRaw[i]
			var id = parseInt(player.u, 10) || 0
			var name = player.n || ''
			var originalName = name

			if (id === userId || usernames.indexOf(name) !== -1) validPlaysIndex.push(parseInt(player.p, 10))
			if (!id && !name) name = 'Unnamed'

			var index = false
			if (id && playersByID[id] !== undefined) index = playersByID[id]
			if (name && index === false && playersByName[name] !== undefined) index = playersByName[name]

			if (index === false) {
				index = players.length
				players.push({
					index: 0,
					self: id === userId || usernames.indexOf(originalName) !== -1,
					id: 0,
					slug: '',
					primaryName: '',
					username: '',
					names: {},
					playerIds: [],
					plays: {},
					games: [],
					counts: [],
					totalPlays: 0,
					totalWins: 0,
					totalGames: 0,
					gameFirst: 0,
					gameLast: 0,
					dateFirst: 0,
					dateLast: 0,
					years: [],
					months: [],
					weeks: [],
					days: []
				})
			}

			if (id) playersByID[id] = index
			if (name) playersByName[name] = index
			if (id) players[index].id = id
			if (player.pid !== undefined && player.pid !== null) players[index].playerIds.push(parseInt(player.pid, 10) || 0)
			if (!players[index].names[name]) players[index].names[name] = 0
			players[index].names[name]++
			players[index].plays[parseInt(player.p, 10)] = parseInt(player.w, 10) || 0
		}

		for (var s = 0; s < players.length; s++) {
			if (players[s].self) this._data.self = players[s]
		}

		players = players.filter(function(player) { return !player.self })
		var validPlaysIndexMap = {}
		for (var vp = 0; vp < validPlaysIndex.length; vp++) validPlaysIndexMap[validPlaysIndex[vp]] = true
		var playerUserIds = players.map(function(player) { return parseInt(player.id, 10) || 0 }).filter(Boolean)
		var playerUsersById = {}
		if (playerUserIds.length) {
			var userRows = Util.queryFast(
				'SELECT user_id, user_name FROM user WHERE user_id IN(' + Util.in(playerUserIds) + ')'
			)
			for (var ur = 0; ur < userRows.length; ur++) {
				playerUsersById[userRows[ur].user_id | 0] = userRows[ur].user_name || ''
			}
		}
		var plays = {}
		var targetPlayerId = (vars && vars.id !== undefined && vars.id !== null)
			? (parseInt(vars.id, 10) || 0)
			: ((filter && filter.playerId !== undefined && filter.playerId !== null) ? (parseInt(filter.playerId, 10) || 0) : 0)

		for (var p = 0; p < players.length; p++) {
			players[p].index = p
			var playCount = 0
			var durationPlays = 0
			var winCount = 0
			var weightTotal = 0
			var durationTotal = 0
			var games = []

			if (players[p].id) {
				if (playerUsersById[players[p].id]) players[p].username = playerUsersById[players[p].id]
				this._references.users.push(parseInt(players[p].id, 10))
			}

			var sortedNames = Object.keys(players[p].names).sort(function(a, b) {
				return players[p].names[b] - players[p].names[a]
			})
			players[p].primaryName = sortedNames[0]
			players[p].slug = Util.slug(Util.englishify(players[p].primaryName))

			var playKeys = Object.keys(players[p].plays)
			for (var pk = 0; pk < playKeys.length; pk++) {
				var currentPlayId = parseInt(playKeys[pk], 10)
				if (!validPlaysIndexMap[currentPlayId] || !playsRaw[currentPlayId]) continue

				if (playsRaw[currentPlayId].l) {
					durationTotal += playsRaw[currentPlayId].l
					durationPlays += playsRaw[currentPlayId].c
				}

				for (var c = 1; c <= playsRaw[currentPlayId].c; c++) {
					players[p].counts.push(playsRaw[currentPlayId].pl)
					games.push(playsRaw[currentPlayId].g)
				}

				if (!plays[currentPlayId]) {
					plays[currentPlayId] = {
						id: currentPlayId,
						d: playsRaw[currentPlayId].d,
						g: playsRaw[currentPlayId].g,
						pl: playsRaw[currentPlayId].pl,
						l: playsRaw[currentPlayId].l,
						c: playsRaw[currentPlayId].c,
						w: playsRaw[currentPlayId].w,
						playersIndex: [],
						playersKey: ''
					}
				}

				plays[currentPlayId].playersIndex.push(p)
				playCount += playsRaw[currentPlayId].c
				weightTotal += playsRaw[currentPlayId].w * playsRaw[currentPlayId].c

				if (players[p].plays[currentPlayId]) {
					winCount += playsRaw[currentPlayId].c
					players[p].plays[currentPlayId] = playsRaw[currentPlayId].c
				}

				if (playsRaw[currentPlayId].d > 0) {
					if (!players[p].dateFirst || players[p].dateFirst > playsRaw[currentPlayId].d) {
						players[p].dateFirst = playsRaw[currentPlayId].d
						players[p].gameFirst = playsRaw[currentPlayId].g
					}
					if (!players[p].dateLast || players[p].dateLast < playsRaw[currentPlayId].d) {
						players[p].dateLast = playsRaw[currentPlayId].d
						players[p].gameLast = playsRaw[currentPlayId].g
					}
					players[p].years.push(parseInt(Util.date('Y', playsRaw[currentPlayId].d), 10))
					players[p].months.push(monthIndex(playsRaw[currentPlayId].d))
					players[p].weeks.push(weekIndex(playsRaw[currentPlayId].d))
					players[p].days.push(dayIndex(playsRaw[currentPlayId].d))
				}
			}

			players[p].counts = Util.array_merge_recursive_distinct({}, countValues(players[p].counts))
			players[p].playYears = countValues(players[p].years)
			players[p].years = Array.from(new Set(players[p].years)).sort(function(a, b) { return a - b })
			players[p].months = Array.from(new Set(players[p].months)).sort(function(a, b) { return a - b })
			players[p].weeks = Array.from(new Set(players[p].weeks)).sort(function(a, b) { return a - b })
			players[p].days = Array.from(new Set(players[p].days)).sort(function(a, b) { return a - b })
			players[p].hindex = hIndex(games)
			players[p].gameCounts = countValues(games)
			players[p].games = Array.from(new Set(games))
			players[p].avgWeight = (weightTotal && playCount) ? Math.round((weightTotal / playCount) * 100) / 100 : 0
			players[p].avgDuration = durationPlays ? Math.round((durationTotal / durationPlays) * 100) / 100 : 0
			players[p].totalDuration = Math.round(durationTotal / 60)
			players[p].durationPlays = durationPlays
			players[p].winRatio = playCount ? (100 / playCount) * winCount : 0
			players[p].totalPlays = playCount
			players[p].totalWins = winCount
			players[p].totalGames = players[p].games.length
			this._data.games = this._data.games.concat(players[p].games)

			if (players[p].slug === filter.player || (targetPlayerId && players[p].playerIds.indexOf(targetPlayerId) !== -1)) {
				this._data.player = players[p]
			}
		}

		if (!this._data.player) return {}

		var filteredPlays = {}
		var playIdsFiltered = Object.keys(plays)
		for (var pf = 0; pf < playIdsFiltered.length; pf++) {
			var currentPlay = plays[playIdsFiltered[pf]]
			if (currentPlay.playersIndex.indexOf(this._data.player.index) !== -1) {
				currentPlay.playersIndex.sort(function(a, b) { return a - b })
				currentPlay.playersKey = currentPlay.playersIndex.join('-')
				filteredPlays[currentPlay.id] = currentPlay
			}
		}

		this._data.games = Array.from(new Set(this._data.games))
		this._data.plays = filteredPlays
		this._data.players = players

		return {
			player: {
				id: parseInt(this._data.player.id, 10) || 0,
				slug: this._data.player.slug,
				name: this._data.player.primaryName,
				username: this._data.player.username,
				totalPlays: this._data.player.totalPlays,
				totalGames: this._data.player.totalGames,
				hindex: parseInt(this._data.player.hindex, 10) || 0
			}
		}
	}
})

function countValues(values) {
	var counts = {}
	for (var i = 0; i < values.length; i++) {
		var value = values[i]
		if (counts[value] === undefined) counts[value] = 0
		counts[value]++
	}
	return counts
}
